import { render, staticRenderFns } from "./CategoryTreeCard.vue?vue&type=template&id=0fdeca75&scoped=true&"
import script from "./CategoryTreeCard.vue?vue&type=script&lang=js&"
export * from "./CategoryTreeCard.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTreeCard.vue?vue&type=style&index=0&id=0fdeca75&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdeca75",
  null
  
)

export default component.exports